import get from 'lodash/get';

import useUser from '../../hooks/useUser';
import {useGetMessagesQuery} from '../../redux/services/messageApi';
import {useGetProvidersQuery} from '../../redux/services/providerApi';
import {useGetSessionsQuery} from '../../redux/services/sessionApi';
import AppDashboard from '../AppDashboard';
import PatientHomeScreen from '../../components/patients/PatientHomeScreen';

const PatientHomePage = props => {
  const user = useUser();
  const messagesQuery = useGetMessagesQuery({}, {skip: false});
  const providersQuery = useGetProvidersQuery(
    {patient_id: get(user, 'patient.id'), is_hidden: false},
    {skip: !user || !user?.patient?.id}
  );
  const sessionsQuery = useGetSessionsQuery(
    {is_upcoming: true},
    {skip: false}
  );
  const unreadMessagesQuery = useGetMessagesQuery(
    {is_read: false, user_to_id: user?.id},
    {skip: !user}
  );
  console.log('providersQuery', providersQuery);
  const childProps = {
    ...props,
    user,
    isPatient: user?.is_patient,
    sessions: sessionsQuery.data?.data || [],
    sessionCount: sessionsQuery.data?.count,
    messages: messagesQuery.data?.data || [],
    messageCount: unreadMessagesQuery.data?.count || 0,
    providers: (providersQuery.data || []).filter(p => p.is_verified),
  };
  return (
    <AppDashboard
      title="Dashboard"
      loading={!user}
      hideBack={true}
      showUser
    >
      <PatientHomeScreen {...childProps} />
    </AppDashboard>
  );
};

export default PatientHomePage;
